var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('regular-container',{attrs:{"label":_vm.label,"description":_vm.description}},[_c('PriceInput',{staticClass:"pricelist-regular-price-input",attrs:{"rules":_vm.priceRules},model:{value:(_vm.currentValue),callback:function ($$v) {_vm.currentValue=$$v},expression:"currentValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }